import { createAuthClient } from 'better-auth/react';
import {
  adminClient,
  customSessionClient,
  inferAdditionalFields,
} from 'better-auth/client/plugins';

import type { AuthServerClient } from '@listening/auth';
import { ac, roles } from '@listening/auth/permissions';
import type { PatchedAuthClient } from '@listening/auth/client-types';

// This is what the code should be, but tsgolint (v0.14) can't resolve
// adminClient() generics — session collapses to `any` in the linter.
// tsgo/tsc resolve it correctly. Remove the cast below and use this
// directly when tsgolint is updated.
// @see https://github.com/oxc-project/tsgolint/issues/864
//
// export const authClient = createAuthClient({
//   plugins: [inferAdditionalFields<AuthServerClient>(), adminClient()],
// });

const _client = createAuthClient({
  plugins: [
    inferAdditionalFields<AuthServerClient>(),
    adminClient({ ac, roles }),
    customSessionClient<AuthServerClient>(),
  ],
});

// oxlint-disable-next-line anti-slop/no-chained-type-assertions -- tsgolint#864
export const authClient = _client as unknown as PatchedAuthClient;

// Re-exports kept for back-compat with callers that imported these types
// from this file before they moved to @listening/auth/client-types.
export type {
  BaseAuthClient,
  PatchedGetSession,
} from '@listening/auth/client-types';
